import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the noisy "Script error." overlay shown by react-error-overlay for
// cross-origin script errors that have already been handled by our own
// try/catch + toast UI. We log them to the console so they remain debuggable.
if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    const msg = event?.message || "";
    if (msg === "Script error." || msg === "ResizeObserver loop limit exceeded") {
      // Cross-origin or harmless errors — already handled in-app, hide overlay
      // eslint-disable-next-line no-console
      console.warn("[suppressed]", msg, event);
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    // eslint-disable-next-line no-console
    console.warn("[unhandledrejection]", event?.reason);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PWA service worker. Only in production-style builds where
// service workers are supported; in CRA dev mode the worker still registers
// at /service-worker.js because it's served from /public.
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[sw] registration failed", err);
      });
  });
}
